import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (isSessionExpiryError(error)) {
        sessionStorage.removeItem('refresh_token');

        if (router.url !== '/logoff') {
          router.navigate(['/logoff'], { state: { logoutSource: 'session_expired' } });
        }
      }

      return throwError(() => error);
    })
  );
};

function isSessionExpiryError(error: unknown): error is HttpErrorResponse {
  if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
    return false;
  }

  if (typeof error.error === 'string') {
    return error.error.includes('Unable to refresh ID token');
  }

  if (error.error && typeof error.error === 'object') {
    const errorMessage = (error.error as Record<string, unknown>)['error'];
    return typeof errorMessage === 'string' && errorMessage.includes('Unable to refresh ID token');
  }

  return false;
}
